

// ACTION  TYPES

import Api from '../../../helpers/Api';

export const SET_VIDEO_SLIDES = 'SET_VIDEO_SLIDES';
const setVideoSlides = (videoSlides) => ({
    type: SET_VIDEO_SLIDES,
    videoSlides,
});


export const SET_RANDOM_VIDEOS = 'SET_RANDOM_VIDEOS';
const setRandomVideo = (randomVideos) => ({
    type: SET_RANDOM_VIDEOS,
    randomVideos,
});


export const SET_LAST_PLAYLIST_ID = 'SET_LAST_PLAYLIST_ID';
const setLastPlaylistId = (lastPlaylistId) => ({
    type: SET_LAST_PLAYLIST_ID,
    lastPlaylistId,
});


// fetch latest videos if needed
export const fetchLatestVideosIfNeeded = (limit = 5) => (dispatch, getState) => {
    const { videoSlides } = getState().videos.videosSlider;

    if (videoSlides.length < 1) {
        return Api.progressGet(dispatch, `/api/v1/videos/getLatestVideos/${limit}`)
            .then((json) => {
                if (json.status === 'success') {
                    return dispatch(setVideoSlides(json.data));
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchLatestVideosIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};


// fetch videos of playlist if needed
export const fetchPlaylistVideosIfNeeded = (playlistId, limit = 5) => (dispatch, getState) => {
    const { lastPlaylistId } = getState().videos.videosSlider;

    if (lastPlaylistId !== playlistId) {
        return Api.progressGet(dispatch, `/api/v1/videos/getVideosByPlaylist/${playlistId}/${limit}`)
            .then((json) => {
                if (json.status === 'success') {
                    const myPromises = [
                        dispatch(setRandomVideo(json.data)),
                        dispatch(setLastPlaylistId(playlistId))];

                    return Promise.all(myPromises);
                }

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log('fetchLatestVideosIfNeeded got error:', error);
            });
    }

    return Promise.resolve(1);
};
